module.exports = __webpack_public_path__ + "amazon_logo.86c6dc59e1af88507e70c2ed5158c731.png";